import {UIBuyFeatureControlsModule} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIBuyFeatureControls/UIBuyFeatureControlsModule';
import {UITurboModePopupModule} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UITurboModePopup/UITurboModePopupModule';
import {UIKoalaPromotionCounterModule} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIPromotionCounter/UIKoalaPromotionCounterModule';
import {UIAutoplayOptionsModule} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIAutoplayOptions/UIAutoplayOptionsModule';
import {UIMainScreenModule} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIMainScreen/UIMainScreenModule';
import {SpinButtonModule} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/SpinButton/SpinButtonModule';
import {BetSelectPopupModule} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/BetSelectPopup/BetSelectPopupModule';
import {IOsFullscreenModule} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/IOsFullscreen/IOsFullscreenModule';
import {JurisdictionZoneModule} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/JurisdictionZone/JurisdictionZoneModule';
import {UIMenuModule} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIMenu/UIMenuModule';

export const modules = [
    UIBuyFeatureControlsModule,
    UIMainScreenModule,
    SpinButtonModule,
    UITurboModePopupModule,
    UIKoalaPromotionCounterModule,
    UIAutoplayOptionsModule,
    BetSelectPopupModule,
    IOsFullscreenModule,
    UIMenuModule,
    JurisdictionZoneModule
];